const Document = {
  Types_0: "Document.Types_0",
  Types_1: "Document.Types_1",
  Types_2: "Document.Types_2",
  Types_3: "Document.Types_3",
  Types_4: "Document.Types_4",
  AddDocument: "Document.AddDocument",
  AttachmentHelpText: "Document.AttachmentHelpText",
  DocumentType: "Document.DocumentType",
  HowToPayInvoice: "Document.HowToPayInvoice",
  TagsHelpText: "Document.TagsHelpText",
  CreateSuccess: "Document.CreateSuccess",
  ReceiptCreateSuccess: "Document.ReceiptCreateSuccess",
  IncomingInvoiceCreateSuccess: "Document.IncomingInvoiceCreateSuccess",
  GenericDocumentCreateSuccess: "Document.GenericDocumentCreateSuccess",
  GenericDocumentCreateSuccessFeatureFlagOff: "Document.GenericDocumentCreateSuccessFeatureFlagOff",
  SIEFiles: "Document.SIEFiles",
  SearchFiles: "Document.SearchFiles",
  UploadSIEFile: "Document.UploadSIEFile",
  SharedDocuments: "Document.SharedDocuments",
  FinancialAccount: "Document.FinancialAccount",
  ChangeName: "Document.ChangeName",
  Document: "Document.Document",
  UpdateSuccessMessage: "Document.UpdateSuccessMessage",
  DeleteSuccessMessage: "Document.DeleteSuccessMessage",
  GenericDocuments: "Document.GenericDocuments",
  GenericDocumentsDescription: "Document.GenericDocumentsDescription",
  UploadGenericDocument: "Document.UploadGenericDocument",
  GenericDocumentState_1: "Document.GenericDocumentState_1",
  GenericDocumentState_0: "Document.GenericDocumentState_0",
  GenericDocumentState_100: "Document.GenericDocumentState_100",
  EditDocument: "Document.EditDocument",
  GoToDocument: "Document.GoToDocument",
  GenericDocumentSentBackTodoTitle: "Document.GenericDocumentSentBackTodoTitle",
  GenericDocumentSentBackTodoSelectionTitle: "Document.GenericDocumentSentBackTodoSelectionTitle",
  GenericDocumentSentBackTodoSelectionSubtitle: "Document.GenericDocumentSentBackTodoSelectionSubtitle",
  GenericDocumentSentBackTodoSubmitSuccess: "Document.GenericDocumentSentBackTodoSubmitSuccess",
  GenericDocumentSentBackTodoAttachmentLoadFailed: "Document.GenericDocumentSentBackTodoAttachmentLoadFailed",
  YourAnswer: "Document.YourAnswer",
  SelectPhotos: "Document.SelectPhotos",
  ExportSIEFile: "Document.ExportSIEFile",
  ExportSIEFileHelpText: "Document.ExportSIEFileHelpText",
  SIEFileExported: "Document.SIEFileExported",
  SIEFileActionType_0: "Document.SIEFileActionType_0",
  SIEFileActionType_1: "Document.SIEFileActionType_1",
  DocumentSentBackTodoMainActionCardHeaderText: "Document.DocumentSentBackTodoMainActionCardHeaderText",
  DocumentSentBackTodoMainActionCardDescription: "Document.DocumentSentBackTodoMainActionCardDescription",
  }
export default Document;